import { clear_auth_storage } from '@/utils/auth/session_manager';

export default {
  name : 'ConfigGlobalSidebar',
  data: () => ({
      is_subsystems_open: false,
      is_management_open: false,
      subsystem_items: [
        {
          label: 'Forms',
          routeName: 'CreateForm'
        },
        {
          label: 'Templates',
          routeName: 'ViewTemplate'
        },
        {
          label: 'Workflows',
          routeName: 'CreateWorkflow'
        },
        {
          label: 'Compliance',
          routeName: 'ComplianceManagement'
        },
        {
          label: 'E-Signing',
          routeName: 'TemplateFormManagement'
        },
        {
          label: 'Verification',
          routeName: 'VerificationForm'
        },
        {
          label: 'Manual Verification',
          routeName: 'ManualVerification'
        },
        {
          label: 'Child Entities',
          routeName: 'ManageSubEntities'
        },
        {
          label: 'Documents',
          routeName: 'ManageDocuments'
        },
        {
          label: 'Invoicing',
          routeName: ''
        },
        {
          label: 'SLA',
          routeName: 'ServiceLayerAgreement'
        },
        {
          label: 'Notifications',
          routeName: 'NotificationManagement'
        },
        {
          label: 'Overrides',
          routeName: ''
        },
        {
          label: 'Risk',
          routeName: 'CreateRiskFramework'
        },
      ]
  }),
  computed: {
    currently_logged_in() {
      return this.$store.getters.currentLeadName || '';
    },
    role() {
      return this.$store.getters.currentRole || '';
    }
  },
  methods: {
    toggle_subsystems() {
      this.is_subsystems_open = !this.is_subsystems_open
    },
    toggle_management() {
      this.is_management_open = !this.is_management_open
    },
    sign_out() {
      clear_auth_storage();
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    },
    close_sidebar() {
      if (window.innerWidth < 992) {
        this.$emit('close');
      }
    }
  }
}
